import { Accordion, TextBody, get } from '@ally/metronome-ui';
import React from 'react';
import styled from 'styled-components';
import { useFeatureFlags } from '../FeatureFlagContext';
import MenuLink from './MenuLink';
import { AccordionMenuItem, StyledSubMenuList } from './StyledMenuComponents';
import { useAccordionClose } from './useAccordionClose';
import { getInvestWealthAllytmln, getInvestWealthText } from './utils';
export const StyledAccordionWrapper = styled(Accordion) `
  border-bottom: 1px solid ${get.colors('slate-2')};
  width: 100%;
  padding: 0;
  & h1 {
    font-size: 16px;
  }
`;
const AccordionSubMenuContent = ({ accordionId, shouldRenderBankLink, shouldRenderInvestLink, shouldRenderMortgageLink, shouldRenderCreditCardLink, shouldRenderVehiclesLink, shouldRenderCreditScoreLink, isInvest, isWealthClient, isWealthDown, isInvestDown, title, ariaLabel, linkInfo, closeMenu, routeInEmber, activeAccordion, updateAccordionState, }) => {
    const featureFlags = useFeatureFlags();
    const { isWealthManagement, isPersonalAdviceEnabled } = featureFlags;
    useAccordionClose({
        accordionId,
        activeAccordion,
        updateAccordionState,
    });
    function investWealthContent() {
        if (isWealthManagement) {
            return getInvestWealthText(!!isInvest, !!isWealthClient, isPersonalAdviceEnabled, !!isWealthDown, !!isInvestDown);
        }
        return 'Invest';
    }
    const accordionItems = [
        shouldRenderBankLink && (React.createElement(MenuLink, { to: linkInfo.bankUrl, text: isWealthManagement ? 'Bank Accounts' : 'Bank', routeInEmber: routeInEmber, accordionName: title, closeMenu: closeMenu })),
        shouldRenderInvestLink && (React.createElement(MenuLink, { to: linkInfo.investUrl, text: investWealthContent(), routeInEmber: routeInEmber, accordionName: title, closeMenu: closeMenu, withAllyTM: getInvestWealthAllytmln(isWealthManagement, isInvest, isWealthClient, isPersonalAdviceEnabled, title) })),
        shouldRenderCreditCardLink && (React.createElement(MenuLink, { to: linkInfo.creditCardUrl, text: "Credit Cards", routeInEmber: routeInEmber, accordionName: title, closeMenu: closeMenu })),
        shouldRenderVehiclesLink && (React.createElement(MenuLink, { to: linkInfo.vehiclesUrl, text: "Vehicles", routeInEmber: routeInEmber, accordionName: title, closeMenu: closeMenu })),
        shouldRenderMortgageLink && (React.createElement(MenuLink, { to: linkInfo.mortgageUrl, text: "Home Loans", routeInEmber: routeInEmber, closeMenu: closeMenu })),
        shouldRenderCreditScoreLink && (React.createElement(MenuLink, { to: linkInfo.creditScoreUrl, text: "Credit Score", accordionName: title, closeMenu: closeMenu })),
    ].filter(Boolean);
    return (React.createElement(StyledSubMenuList, { "aria-label": ariaLabel }, accordionItems.map((link, index) => {
        const focusProps = { tabIndex: -1 };
        const firstMenuItem = index === 0;
        return (React.createElement(AccordionMenuItem, null,
            React.createElement(TextBody, Object.assign({ tag: "span", size: "sm" }, (firstMenuItem ? focusProps : {})), link)));
    })));
};
export default function AccordionSubMenu(props) {
    const { instanceKey, title } = props;
    return (React.createElement(StyledAccordionWrapper, { dataTestId: instanceKey, key: instanceKey, disableContainer: true, items: [
            {
                heading: title,
                panel: React.createElement(AccordionSubMenuContent, Object.assign({}, props)),
                dataTracking: {
                    name: `${title} - profile panel`,
                    trigger: 'profile panel',
                },
            },
        ] }));
}
//# sourceMappingURL=AccordionSubMenu.js.map